import {
  DrawerSelectField,
  EfsMelcoEfsModelsFormat,
  useDrawer,
} from "melco-shared-logic";
import {
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  PlusIcon,
  Row,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import { ServiceType } from "../../helper/serviceType";
import { useDesignConfiguration } from "../../hooks/designMappings/useDesignConfiguration";
import { EmptyWrapper } from "../shared/EmptyWrapper";
import { ChooseDesignDrawer } from "./ChooseDesignDrawer";
import { DisplayNameOfDesign } from "./DisplayNameOfDesign";
import { ManageDesignConfiguration } from "./ManageDesignConfiguration";

const { spacings } = DesignTokens;

type DesignConfigurationProps = {
  inputFormat: EfsMelcoEfsModelsFormat | undefined;
  serviceType: ServiceType;
};

export const DesignConfiguration: React.FC<DesignConfigurationProps> = ({
  inputFormat,
  serviceType,
}) => {
  const { t } = useTranslation();

  const { selectedDesignId, designIdField, onDesignSelect } =
    useDesignConfiguration();

  const drawer = useDrawer([designIdField]);

  if (!inputFormat) {
    return null;
  }

  return (
    <>
      <Title level={5}>
        {t("designMappings.detail.form.designConfiguration.title")}
      </Title>

      {!selectedDesignId ? (
        <FullWidthSpace direction="vertical">
          <EmptyWrapper data-cy-id="design-configuration-empty-wrapper">
            <Button
              type="primary"
              icon={<PlusIcon />}
              onClick={drawer.openDrawer}
            >
              {t(
                "designMappings.actions.designConfiguration.chooseDesign.button"
              )}
            </Button>
          </EmptyWrapper>
        </FullWidthSpace>
      ) : (
        <div data-cy-id="design-configuration-wrapper">
          <Row gutter={[spacings.middle, 0]}>
            <Col xs={24} md={12}>
              <DrawerSelectField
                type="choose"
                field={designIdField}
                drawer={drawer}
                render={(designId) =>
                  designId && <DisplayNameOfDesign designId={designId} />
                }
              />
            </Col>
          </Row>

          <ManageDesignConfiguration
            designId={selectedDesignId}
            inputFormatId={inputFormat.id!}
            serviceType={serviceType}
          />
        </div>
      )}

      <ChooseDesignDrawer
        drawer={drawer}
        onDesignSelect={onDesignSelect}
        serviceType={serviceType}
      />
    </>
  );
};
